import React, { useContext } from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import { ThemeContext } from '../context/ThemeContext';
import { useReducedMotionPreferred } from '../hooks/useReducedMotionPreferred';

const MotionDiv = motion.div;

const ThemeToggle = ({ sx = {} }) => {
  const { mode, toggleTheme } = useContext(ThemeContext);
  const theme = useTheme();
  const reducedMotion = useReducedMotionPreferred();
  const isDark = mode === 'dark';

  const iconVariants = reducedMotion
    ? { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }
    : {
        initial: { opacity: 0, scale: 0.6, rotate: -30 },
        animate: { opacity: 1, scale: 1, rotate: 0 },
        exit: { opacity: 0, scale: 0.6, rotate: 30 },
      };

  return (
    <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
      <IconButton
        onClick={toggleTheme}
        color="inherit"
        aria-pressed={isDark}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        sx={{ position: 'relative', ...sx }}
      >
        <AnimatePresence mode="wait" initial={false}>
          {isDark ? (
            <MotionDiv
              key="sun"
              variants={iconVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: reducedMotion ? 0.1 : 0.2, ease: 'easeOut' }}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <Brightness7 />
            </MotionDiv>
          ) : (
            <MotionDiv
              key="moon"
              variants={iconVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: reducedMotion ? 0.1 : 0.2, ease: 'easeOut' }}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <Brightness4 />
            </MotionDiv>
          )}
        </AnimatePresence>
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
